import { Box, Button, Flex, Text, TextInput } from "@mantine/core";
import { IconCheck } from "@tabler/icons-react";
import axios from "axios";
import { useState } from "react";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { repositoryDelivery } from "../../../_base/_const/_constVar";
import { MessageResponse } from "../../../model/MessageResponse";
import { modals } from "@mantine/modals";

const CancelGHTKAndAhamove = ({
  type,
  sourceCode,
  onSuccess,
}: {
  type: string;
  sourceCode: string;
  onSuccess: any;
}) => {
  const [reasonCancellation, setReasonCancellation] = useState<string>("");

  const handleUpdateCancelAhamove = async (dataMessage: string) => {
    const res = await repositoryDelivery.post<MessageResponse<any>>(
      "/api/v1/Ahamove/cancel-order",
      { orderNumber: sourceCode, message: JSON.stringify(dataMessage) },
    );

    if (res) {
      NotificationExtension.Success("Hủy đơn giao hàng Ahamove thành công !");
    } else {
      NotificationExtension.Fails("Có lỗi xảy ra khi cập nhập lại đơn hàng !");
    }
  };

  const handleCancelGHTK = async () => {
    const response = await repositoryDelivery.post<MessageResponse<any>>(
      "/api/v1/GHTK/cancel-order",
      {
        orderNumber: sourceCode,
      },
    );

    if (response && response.success) {
      NotificationExtension.Success(response?.message);
      setTimeout(() => {
        modals.closeAll();
        onSuccess((prev: any) => !prev);
      }, 1000);
    } else {
      NotificationExtension.Fails(response?.message);
    }
  };

  const handleCancelAhamove = async () => {
    try {
      const response = await axios.delete(
        "https://partner-apistg.ahamove.com/v3/orders/tracks",
        {
          headers: {
            "Content-Type": "application/json",
            Authorization:
              "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0eXAiOiJ1c2VyIiwiY2lkIjoiODQ5NjQ2MzUxMzYiLCJzdGF0dXMiOiJPTkxJTkUiLCJlb2MiOiJ2YW52aW5oc3B1ckBnbWFpbC5jb20iLCJub2MiOiJDw7RuZyB0eSBD4buVIHBo4bqnbiDEkOG6p3UgdMawIEPDtG5nIG5naOG7hyBIQUNPTSBBZG1pbiIsImN0eSI6IlNHTiIsInR5cGUiOiJhcGkiLCJwYXJ0bmVyIjoiaGFjb20iLCJleHAiOjE4MTY5NDM5MDUsImlhdCI6MTc1Mzg3MTkwNSwiaXNzIjoiYWhhIn0.fO6fONjUfp2KzIlgYX5HjeNa06UfFxa1BEVHANnrj7U", // 🔁 Thay <token> bằng token thật từ Postman
          },
          data: {
            tracking_number: sourceCode,
            comment: reasonCancellation,
          },
        },
      );

      if (response) {
        NotificationExtension.Success("Hủy đơn giao hàng Ahamove thành công !");
        handleUpdateCancelAhamove(response.data);
        setTimeout(() => {
          modals.closeAll();
          onSuccess((prev: any) => !prev);
        }, 1000);
      } else {
        NotificationExtension.Fails("Hủy đơn giao hàng Ahamove thất bại !");
      }
    } catch (error: any) {
      console.error(
        "Ahamove API error:",
        error.response?.data || error.message,
      );
      return error.response?.data || error.message;
    }
  };

  return (
    <Box>
      <Text fw={500} mt={10} size="20px">
        Bạn có chắc muốn hủy đơn giao hàng{" "}
        {type === "GHTK" ? "GHTK" : "Ahamove"} này ?
      </Text>
      {type === "GHTK" ? (
        <></>
      ) : (
        <TextInput
          mt={5}
          label="Lí do hủy đơn"
          placeholder="Nhập lí do hủy đơn"
          value={reasonCancellation}
          onChange={(e) => setReasonCancellation(e.currentTarget.value)}
        />
      )}
      <Flex justify={"end"} gap={"md"} mt={10}>
        <Button
          color="green"
          variant="outline"
          leftSection={<IconCheck size={14} />}
          onClick={() => {
            if (type === "Ahamove") {
              handleCancelAhamove();
            } else if (type === "GHTK") {
              handleCancelGHTK();
            }
          }}
        >
          Xác nhận
        </Button>
      </Flex>
    </Box>
  );
};

export default CancelGHTKAndAhamove;
